import {createSlice} from "@reduxjs/toolkit";
import {PURGE} from "redux-persist";

const initialState = {
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const {setUnreadCount} = notificationSlice.actions;
export default notificationSlice.reducer;
